import * as types from "./types";

/*---------------------------------------------------------------------------*/

function resetDataSaved() {
  return { type: types.RESET_DATA_SAVED };
}

function saveData(payload) {
  return { type: types.DATA_SAVED, payload };
}

/*---------------------------------------------------------------------------*/

function addedCitaDeVenta(payload) {
  return { type: types.ADDED_CITA_DE_VENTA, payload };
}
function removedCitaDeVenta(payload) {
  return { type: types.REMOVED_CITA_DE_VENTA, payload };
}
function changedCitaDeVenta(payload) {
  return { type: types.CHANGED_CITA_DE_VENTA, payload };
}

/*---------------------------------------------------------------------------*/

function limpiarCitasDeVenta() {
  return { type: types.LIMPIAR_CITAS_DE_VENTA };
}

export {
  saveData,
  resetDataSaved,
  addedCitaDeVenta,
  removedCitaDeVenta,
  changedCitaDeVenta,
  limpiarCitasDeVenta
};



// WEBPACK FOOTER //
// ./src/ducks/ventasCitas/actions.js